var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orphan_Donation_History",
    "data-name": "Orphan Donation History",
    transform: "translate(-1.5 -5.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10191",
    "data-name": "Path 10191",
    d: "M27.981,15.622a1.2,1.2,0,0,0-.956.678A11.426,11.426,0,0,0,16,6.7,11.426,11.426,0,0,0,4.975,16.3a1.2,1.2,0,0,0-.956-.678c-.844,0-1.519,1.355-1.519,3.049s.675,3.049,1.519,3.049a1.2,1.2,0,0,0,.956-.678A11.425,11.425,0,0,0,16,30.7a11.425,11.425,0,0,0,11.025-9.656,1.125,1.125,0,0,0,.956.678c.844,0,1.519-1.355,1.519-3.049S28.825,15.622,27.981,15.622Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10192",
    "data-name": "Path 10192",
    d: "M23.944,6.7a6.559,6.559,0,0,1,2.419,4.235v.282a2.424,2.424,0,0,1-2.531,2.2,2.364,2.364,0,0,1-2.194-2.2,2.054,2.054,0,0,1,.675-1.581M21.3,22.851a7.181,7.181,0,0,0,5.906,0",
    transform: "translate(-8.225 1)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 0.788,
    transform: "translate(19.431 17.712)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 0.844,
    transform: "translate(11.781 17.712)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10194",
    "data-name": "Path 10194",
    d: "M32.6,7.6a4.617,4.617,0,0,1,1.125,4.744",
    transform: "translate(-13.169 -0.392)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidIcon);
export default __webpack_public_path__ + "static/media/kidIcon.561539acc47570568c402e3406d3a662.svg";
export { ForwardRef as ReactComponent };